export default __webpack_public_path__ + "static/media/chatlogo.0be2e6a0.svg";